import { render, staticRenderFns } from "./PersonalStatisticModal.vue?vue&type=template&id=72f66b0b"
import script from "./PersonalStatisticModal.vue?vue&type=script&lang=js"
export * from "./PersonalStatisticModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalStatisticModal.vue?vue&type=style&index=0&id=72f66b0b&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports